import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry as getMicrofrontendsRegistry } from '@cian/mf-registry/browser';

import { IApplicationContext, IApplicationContextCustom } from 'shared/types/applicationContext';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
    httpApi: getHttpApi(),
    logger: getLogger(),
    microfrontendsAPI: config.get<boolean>('header.asMicrofrontend') ? createMicrofrontendsAPI() : undefined,
    microfrontendsRegistry: getMicrofrontendsRegistry(),
  };
};
